import React from 'react'
import { Text } from '@chakra-ui/react'

import { Card, FieldList, FieldListItem } from 'components'

export const ReportProjectIDCard = ({ loading, report, ...props }) => (
  <Card {...props} heading='Identificação do Projeto'>
    <FieldList isLoading={loading}>
      <FieldListItem label='Projeto'>
        <Text>{report?.user.entity.projects[0].name}</Text>
      </FieldListItem>
      <FieldListItem label='Maturidade'>
        <Text>{report?.user.entity.projects[0].stage.name}</Text>
      </FieldListItem>
      <FieldListItem label='Setores'>
        <Text>{report?.user.entity.projects[0].sectors.map(({ name }) => name).join(', ')}</Text>
      </FieldListItem>
    </FieldList>
  </Card>
)

export default ReportProjectIDCard
